import { CircularProgress } from '@mui/material'

const LoadingIndicator = () => {
  return (
    <div className="flex flex-col items-center justify-center mt-36">
      <CircularProgress className="text-primary" size={50} />
    </div>
  )
}

export default LoadingIndicator
